export default __webpack_public_path__ + "static/media/interior.517d8641.jpg";